import { useState } from 'react';
import { useDebounce } from '@logz-pkg/react-hooks';
import { useSelectState } from '../../../SmartSelect.provider';
import { useLuceneValidation } from 'ui/hooks/queries/lucene-validation-hook';

export type UseValidate = {
  isInputValid: boolean;
  isFilterValid: boolean;
  isLoading: boolean;
};

export const useSmartValidate = (inputValue: string): UseValidate => {
  const [debouncedValue, setDebouncedValue] = useState(inputValue);
  const { isFilterValidO } = useSelectState();

  useDebounce(inputValue, () => setDebouncedValue(inputValue), 350);

  const { isValid: isInputValid, isFetching: isFetchingInput } = useLuceneValidation(debouncedValue);

  const shouldRetryWithQuotes = !isInputValid && !isFetchingInput;

  const { isValid: isFilterValid, isFetching: isFetchingFilter } = useLuceneValidation(
    shouldRetryWithQuotes ? `"${debouncedValue}"` : debouncedValue,
  );

  const isDebouncing = debouncedValue !== inputValue;
  const isFetching = isFetchingInput || isFetchingFilter || isDebouncing;

  isFilterValidO.set(isFilterValid);

  return { isLoading: isFetching, isInputValid, isFilterValid };
};
